document.querySelectorAll('[data-category-slider]').forEach((slider) => {
  const section = slider.closest('.collection-category-navigation');
  const previous = section.querySelector('[data-category-prev]');
  const next = section.querySelector('[data-category-next]');

  const scrollAmount = () => {
    const card = slider.querySelector('.collection-category-card');
    return card ? card.getBoundingClientRect().width + 1 : 320;
  };

  const updateControls = () => {
    const maxScroll = slider.scrollWidth - slider.clientWidth;
    previous.disabled = slider.scrollLeft <= 2;
    next.disabled = slider.scrollLeft >= maxScroll - 2;
  };

  previous.addEventListener('click', () => slider.scrollBy({ left: -scrollAmount(), behavior: 'smooth' }));
  next.addEventListener('click', () => slider.scrollBy({ left: scrollAmount(), behavior: 'smooth' }));
  slider.addEventListener('scroll', updateControls, { passive: true });
  window.addEventListener('resize', updateControls);
  updateControls();
});
